import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Loader } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin`;

export default function ComplianceCreditNotes() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const r = await axios.get(`${API}/invoices/credit-notes`, {
          withCredentials: true,
          params: { limit: 100 },
        });
        setRows(r.data?.credit_notes || r.data?.rows || []);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center py-12">
        <Loader className="w-8 h-8 animate-spin text-gray-400" />
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-bold text-gray-900">Credit Notes</h2>
      <p className="text-sm text-gray-500">GST credit notes issued on cancellations</p>
      <div className="bg-white border border-gray-200 rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-left">
            <tr>
              <th className="px-4 py-2">Invoice #</th>
              <th className="px-4 py-2">Booking</th>
              <th className="px-4 py-2">Date</th>
              <th className="px-4 py-2">Amount</th>
              <th className="px-4 py-2">PDF</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && (
              <tr><td colSpan={5} className="px-4 py-8 text-center text-gray-500">No credit notes found</td></tr>
            )}
            {rows.map((cn) => (
              <tr key={cn.id || cn.invoice_number} className="border-t border-gray-100">
                <td className="px-4 py-2 font-mono text-xs">{cn.invoice_number || cn.credit_note_number}</td>
                <td className="px-4 py-2">{cn.booking_id}</td>
                <td className="px-4 py-2">{(cn.issued_at || cn.created_at || '').slice(0, 10)}</td>
                <td className="px-4 py-2">₹{Number(cn.total_amount || cn.taxable_value || 0).toLocaleString('en-IN')}</td>
                <td className="px-4 py-2">
                  {cn.pdf_url && (
                    <a href={cn.pdf_url} target="_blank" rel="noreferrer" className="text-[#1B375B] underline text-xs">Download</a>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
